export * from './iconFontAwesomeEmojiFaceSmile';
export * from './iconFontAwesomeEmojiFaceTired';
export * from './iconFontAwesomeEmojiFaceSurprise';
export * from './iconFontAwesomeEmojiFaceSmileWink';
export * from './iconFontAwesomeEmojiFaceSmileBeam';
export * from './iconFontAwesomeEmojiFaceSadTear';
export * from './iconFontAwesomeEmojiFaceSadCry';
export * from './iconFontAwesomeEmojiFaceRollingEyes';
export * from './iconFontAwesomeEmojiFaceMehBlank';
export * from './iconFontAwesomeEmojiFaceMeh';
export * from './iconFontAwesomeEmojiFaceLaughWink';
export * from './iconFontAwesomeEmojiFaceLaughSquint';
export * from './iconFontAwesomeEmojiFaceLaughBeam';
export * from './iconFontAwesomeEmojiFaceLaugh';
export * from './iconFontAwesomeEmojiFaceKissWinkHeart';
export * from './iconFontAwesomeEmojiFaceKissBeam';
export * from './iconFontAwesomeEmojiFaceKiss';
export * from './iconFontAwesomeEmojiFaceGrinWink';
export * from './iconFontAwesomeEmojiFaceGrinWide';
export * from './iconFontAwesomeEmojiFaceGrinTongueWink';
export * from './iconFontAwesomeEmojiFaceGrinTongueSquint';
export * from './iconFontAwesomeEmojiFaceGrinTongue';
export * from './iconFontAwesomeEmojiFaceGrinTears';
export * from './iconFontAwesomeEmojiFaceGrinStars';
export * from './iconFontAwesomeEmojiFaceGrinSquintTears';
export * from './iconFontAwesomeEmojiFaceGrinSquint';
export * from './iconFontAwesomeEmojiFaceGrinHearts';
export * from './iconFontAwesomeEmojiFaceGrinBeamSweat';
export * from './iconFontAwesomeEmojiFaceGrinBeam';
export * from './iconFontAwesomeEmojiFaceGrin';
export * from './iconFontAwesomeEmojiFaceGrimace';
export * from './iconFontAwesomeEmojiFaceFrownOpen';
export * from './iconFontAwesomeEmojiFaceFrown';
export * from './iconFontAwesomeEmojiFaceFlushed';
export * from './iconFontAwesomeEmojiFaceDizzy';
export * from './iconFontAwesomeEmojiFaceAngry';
